export const APPLE_PAY_VERSION = 3
